export const commonColors = {
  protein: "#1976D2",
  carbs: "#7A3B69",
  fat: "#F5B041",
};
